// frontend/src/pages/admin/AdminDashboard.jsx (نسخه نهایی و حرفه‌ای)

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaUsers, FaChalkboardTeacher, FaUserGraduate, FaSitemap, FaPlusCircle, FaChartBar } from 'react-icons/fa';
import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api'; // فرض می‌کنیم این فایل وجود دارد

// ==============================================================================
// 1. کامپوننت‌های ماژولار و قابل استفاده مجدد
// ==============================================================================

/**
 * کارت نمایش آمار کلان با آیکون و لینک
 */
const StatCard = ({ title, value, icon, link, color }) => (
    <div className="stat-card" style={{ borderTop: `4px solid ${color}` }}>
        <div className="stat-card-header">
            <span>{title}</span>
            {React.cloneElement(icon, { style: { color } })}
        </div>
        <p className="stat-card-value">{value}</p>
        <Link to={link} className="stat-card-footer" style={{ color }}>
            مشاهده و مدیریت &larr;
        </Link>
    </div>
);

/**
 * بنر خوش‌آمدگویی و لینک‌های سریع
 */
const WelcomeBanner = ({ userFullName, userRole }) => {
    // تابعی برای تبدیل نقش انگلیسی به فارسی خوانا
    const getRoleNameInFarsi = (role) => {
        const roles = {
            NationalAdmin: 'مدیر کل کشور',
            ProvinceAdmin: 'مدیر استان',
            CityAdmin: 'مدیر شهرستان',
            SchoolAdmin: 'مدیر مدرسه',
        };
        return roles[role] || 'مدیر سامانه';
    };

    return (
        <div className="admin-welcome-banner">
            <h1>داشبورد مدیریتی سُهات</h1>
            <p>{userFullName} | نقش: <strong>{getRoleNameInFarsi(userRole)}</strong></p>
            <div className="admin-quick-links">
                {/* لینک‌های سریع می‌توانند بر اساس نقش تغییر کنند */}
                <Link to="/admin/users"><FaUsers /> مدیریت کاربران</Link>
                <Link to="/admin/organizations"><FaSitemap /> مدیریت سازمان‌ها</Link>
            </div>
        </div>
    );
};


// ==============================================================================
// 2. کامپوننت اصلی داشبورد مدیریت
// ==============================================================================
const AdminDashboard = () => {
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // خواندن اطلاعات کاربر از حافظه مرورگر
    const userRole = localStorage.getItem('userRole');
    const userFullName = localStorage.getItem('userFullName') || 'مدیر محترم';

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                // در آینده، یک API در بک‌اند می‌سازیم که بر اساس نقش کاربر، آمار مناسب را برمی‌گرداند
                // const response = await axios.get(`${API_BASE_URL}/admin/dashboard-summary/`, getAuthHeaders());
                // setStats(response.data);

                // === استفاده از داده‌های موقت برای نمایش ===
                // این داده‌ها بر اساس نقش کاربر شبیه‌سازی شده‌اند
                let mockData = {};
                if (userRole === 'NationalAdmin') {
                    mockData = { total_provinces: 31, total_teachers: 50000, total_students: 1200000 };
                } else if (userRole === 'ProvinceAdmin') {
                    mockData = { total_cities: 25, total_teachers: 4500, total_students: 98000 };
                } else if (userRole === 'SchoolAdmin') {
                    mockData = { total_classes: 30, total_teachers: 52, total_students: 850 };
                } else { // برای بقیه مدیران
                     mockData = { total_schools: 120, total_teachers: 1200, total_students: 25000 };
                }
                setStats(mockData);
                // =======================================

            } catch (err) {
                setError("خطا در دریافت اطلاعات داشبورد.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchDashboardData();
    }, [userRole]); // هر بار که نقش عوض شود، داده‌ها دوباره خوانده می‌شوند (برای آینده)


    // نمایش محتوای شرطی بر اساس نقش کاربر
    const renderStats = () => {
        if (loading) return <p>در حال بارگذاری آمار...</p>;
        if (error) return <p className="error-message">{error}</p>;

        switch (userRole) {
            case 'NationalAdmin':
                return (
                    <>
                        <StatCard title="تعداد کل استان‌ها" value={stats.total_provinces?.toLocaleString('fa-IR')} icon={<FaSitemap />} link="/admin/organizations?type=province" color="#007bff" />
                        <StatCard title="تعداد کل معلمان" value={stats.total_teachers?.toLocaleString('fa-IR')} icon={<FaChalkboardTeacher />} link="/admin/users?role=teacher" color="#28a745" />
                        <StatCard title="تعداد کل دانش‌آموزان" value={stats.total_students?.toLocaleString('fa-IR')} icon={<FaUserGraduate />} link="/admin/users?role=student" color="#ffc107" />
                        <StatCard title="گزارشات جامع کشوری" value="مشاهده" icon={<FaChartBar />} link="/admin/reports/national" color="#dc3545" />
                    </>
                );
            case 'ProvinceAdmin':
                 return (
                    <>
                        <StatCard title="تعداد شهرستان‌ها" value={stats.total_cities?.toLocaleString('fa-IR')} icon={<FaSitemap />} link="/admin/organizations?type=city" color="#007bff" />
                        <StatCard title="معلمان استان" value={stats.total_teachers?.toLocaleString('fa-IR')} icon={<FaChalkboardTeacher />} link="/admin/users?role=teacher" color="#28a745" />
                        <StatCard title="دانش‌آموزان استان" value={stats.total_students?.toLocaleString('fa-IR')} icon={<FaUserGraduate />} link="/admin/users?role=student" color="#ffc107" />
                        <StatCard title="گزارشات استانی" value="مشاهده" icon={<FaChartBar />} link="/admin/reports/province" color="#dc3545" />
                    </>
                );
            case 'SchoolAdmin':
                return (
                    <>
                        <StatCard title="تعداد کلاس‌ها" value={stats.total_classes?.toLocaleString('fa-IR')} icon={<FaSitemap />} link="/admin/classes" color="#007bff" />
                        <StatCard title="معلمان مدرسه" value={stats.total_teachers?.toLocaleString('fa-IR')} icon={<FaChalkboardTeacher />} link="/admin/users?role=teacher" color="#28a745" />
                        <StatCard title="دانش‌آموزان مدرسه" value={stats.total_students?.toLocaleString('fa-IR')} icon={<FaUserGraduate />} link="/admin/users?role=student" color="#ffc107" />
                        <StatCard title="ثبت کاربر جدید" value="افزودن" icon={<FaPlusCircle />} link="/admin/users/create" color="#17a2b8" />
                    </>
                );
            default: // برای بقیه مدیران (شهر، ناحیه و...)
                return (
                    <>
                        <StatCard title="تعداد مدارس تحت پوشش" value={stats.total_schools?.toLocaleString('fa-IR')} icon={<FaSitemap />} link="/admin/organizations?type=school" color="#007bff" />
                        <StatCard title="معلمان منطقه" value={stats.total_teachers?.toLocaleString('fa-IR')} icon={<FaChalkboardTeacher />} link="/admin/users?role=teacher" color="#28a745" />
                        <StatCard title="دانش‌آموزان منطقه" value={stats.total_students?.toLocaleString('fa-IR')} icon={<FaUserGraduate />} link="/admin/users?role=student" color="#ffc107" />
                        <StatCard title="گزارشات منطقه" value="مشاهده" icon={<FaChartBar />} link="/admin/reports/regional" color="#dc3545" />
                    </>
                );
        }
    };

    return (
        <div className="admin-dashboard-container">
            <WelcomeBanner userFullName={userFullName} userRole={userRole} />
            
            <div className="admin-stats-grid">
                {renderStats()}
            </div>

            {/* بخش‌های دیگر مانند نمودارها و جداول می‌توانند در آینده اینجا اضافه شوند */}
        </div>
    );
};

export default AdminDashboard;